<template>
    <Card>

        <template slot="title">
            Accepted Quote
        </template>

        <template slot="actions">
            <b-btn
                v-if="shouldShowAcceptedQuote"
                size="sm"
                variant="primary"
                :href="acceptedQuote.view_link"
            >
                View
            </b-btn>
        </template>

        <template v-if="shouldShowAcceptedQuote">
            <div class="mb-2">
                <div class="d-flex justify-content-between">
                    <div class="font-weight-bold">
                        Event Management Fee
                    </div>
                    <b-btn
                        size="sm"
                        variant="link"
                        class="p-0"
                        @click="openEditPricingModeModal"
                    >
                        <i class="fa fa-pencil" />
                    </b-btn>
                </div>
                <div>{{ formatCurrency(acceptedQuote.data.event_management_fee) }}</div>
            </div>
            <div class="mb-2">
                <div class="font-weight-bold">
                    Total Cost
                </div>
                <div>{{ formatCurrency(acceptedQuote.data.total_cost) }}</div>
            </div>
            <div class="mb-2">
                <div class="font-weight-bold">
                    Total Price
                </div>
                <div>{{ formatCurrency(acceptedQuote.data.total_price) }}</div>
            </div>
            <div
                v-if="acceptedQuote.data.price_per_guest != null"
                class="mb-2"
            >
                <div class="font-weight-bold">
                    Price Per Guest
                </div>
                <div>{{ formatCurrency(acceptedQuote.data.price_per_guest) }}</div>
            </div>
            <div class="mb-2">
                <div class="font-weight-bold">
                    Markup
                </div>
                <div>{{ formatCurrency(acceptedQuote.data.markup) }}</div>
            </div>
            <div class="mb-2">
                <div class="font-weight-bold">
                    Margin
                </div>
                <div>{{ formatPercentage(acceptedQuote.data.margin) }}</div>
            </div>
            <div class="mb-2">
                <div class="font-weight-bold">
                    Margin Incl. Commission
                </div>
                <div>{{ formatPercentage(acceptedQuote.data.margin_including_commission) }}</div>
            </div>
            <div class="mb-2">
                <div class="font-weight-bold">
                    Commission
                </div>
                <div>{{ formatCurrency(acceptedQuote.data.commission) }}</div>
            </div>
            <div class="mb-2">
                <div class="font-weight-bold">
                    Profit
                </div>
                <div>{{ formatCurrency(acceptedQuote.data.profit) }}</div>
            </div>
            <div class="mb-2">
                <div class="font-weight-bold">
                    Created At
                </div>
                <div>{{ acceptedQuote.data.created_at }}</div>
                <div class="small text-muted">
                    {{ new Date(acceptedQuote.data.created_at) | moment('from', 'now') }}
                </div>
            </div>
            <div
                v-if="acceptedQuote.data.sent_at"
                class="mb-2"
            >
                <div class="font-weight-bold">
                    Sent At
                </div>
                <div>{{ acceptedQuote.data.sent_at }}</div>
                <div class="small text-muted">
                    {{ new Date(acceptedQuote.data.sent_at) | moment('from', 'now') }}
                </div>
            </div>
            <div
                v-if="acceptedQuote.data.accepted_at"
                class="mb-2"
            >
                <div class="font-weight-bold">
                    Accepted At
                </div>
                <div>{{ acceptedQuote.data.accepted_at }}</div>
                <div class="small text-muted">
                    {{ new Date(acceptedQuote.data.accepted_at) | moment('from', 'now') }}
                </div>
            </div>
            <div
                v-if="acceptedQuote.data.declined_at"
                class="mb-2"
            >
                <div class="font-weight-bold">
                    Declined At
                </div>
                <div>{{ acceptedQuote.data.declined_at }}</div>
                <div class="small text-muted">
                    {{ new Date(acceptedQuote.data.declined_at) | moment('from', 'now') }}
                </div>
            </div>
            <div>
                <div class="font-weight-bold">
                    Updated At
                </div>
                <div>{{ acceptedQuote.data.updated_at }}</div>
                <div class="small text-muted">
                    {{ new Date(acceptedQuote.data.updated_at) | moment('from', 'now') }}
                </div>
            </div>
        </template>
        <template v-else>
            Event does not have an accepted quote.
        </template>

    </Card>
</template>

<script>
import Card from '@/components/Card';
import * as helpers from '@/utils/helpers';
import api from '../_api';

export default {

    components: {
        Card,
    },

    computed: {
        acceptedQuote() {
            return this.$store.getters['costable/acceptedQuote'];
        },
        costableType() {
            return this.$store.getters['costable/costableType'];
        },
        costableId() {
            return this.$store.getters['costable/costableId'];
        },
        shouldShowAcceptedQuote() {
            return !!this.acceptedQuote;
        },
    },

    methods: {
        ...helpers,
        openEditPricingModeModal() {
            this.$eventBus.$emit(this.$events.openEditPricingModeModal, {
                title: 'Change Quote Pricing Mode',
                quote: true,
                onOpen: () => api.getQuotePricingMode(this.costableType, this.costableId, this.acceptedQuote.data.id),
                onSubmit: data => this.$store.dispatch('costable/updateQuotePricingMode', {
                    acceptedQuoteId: this.acceptedQuote.data.id,
                    ...data,
                }),
            });
        },
    },

};
</script>
